var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.plot
        ? _c("PlotChange", {
            attrs: {
              "novel-id": _vm.novelId,
              plotId: _vm.effectivePlotId,
              plot: _vm.plot,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }